<template>
    <v-row class="coor-dash">
        <template v-for="(menu,index) in menus">         
            <v-col v-if="!menu.hideFromDashBoard && showUpgradeGoldCard(menu)" cols="4" :key="index" class="d-flex flex-column">
                <v-card class="mx-auto card-dashboard flex d-flex flex-column">
                    <v-list-item :to="menu.toRoute" class="border-btm">
                        <v-list-item-avatar tile size="80" :color="menu.dashBoardBGColor">
                            <img :src="menu.dashBoardIcon" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="headline mb-1">{{menu.label}}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <div class="card-data">
                        <div v-for="(sub_menu,i) in menu.sub_menus" :key="i" v-if="!sub_menu.hideFromDashBoard" class="info-col">
                            <template v-if="!sub_menu.hideFromDashBoard">
                                <v-list-item dense :to="{
                                  name: sub_menu.toRoute,
                                  params: { resetPage: true },}">
                                    <v-list-item-title v-text="sub_menu.text"></v-list-item-title>
                                </v-list-item>
                            </template>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </template>

        <!-- <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="batches-icon">
                  <img src="../../assets/img/svg/batches.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">Batches</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">Create Batches</div>
              <div class="info-col">Manage Batches</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="users-icon">
                  <img src="../../assets/img/svg/users.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">Users</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">Add Users</div>
              <div class="info-col">Batch Allocation</div>
              <div class="info-col">Approve Users</div>
              <div class="info-col">Monitor Users</div>
              <div class="info-col">Manage Userts</div>
              <div class="info-col">Edit Users</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="profile-icon">
                  <img src="../../assets/img/svg/profile.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">My Settings</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">Edit Photo</div>
              <div class="info-col">Edit Info</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="tests-icon">
                  <img src="../../assets/img/svg/tests.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">Tests</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">Complimentary Tests</div>
              <div class="info-col">Customized Tests</div>
              <div class="info-col">All India Test Series</div>
              <div class="info-col">Scheduled Tests</div>
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="mx-auto card-dashboard">
            <v-list-item class="border-btm">
                <v-list-item-avatar tile size="80" color="result_analysis-icon">
                  <img src="../../assets/img/svg/result_analysis.svg"/>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">Result Analysis</v-list-item-title>
                </v-list-item-content>            
            </v-list-item>
            <div class="card-data">
              <div class="info-col">Test Results</div>
              <div class="info-col">Batch Health</div>
              <div class="info-col">Studentwise Health</div>
            </div>
          </v-card>
        </v-col>-->
    </v-row>
</template>

<script>
import menuList from "../../utils/menu";
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
export default {
    name: "DashboardCoordinator",
    data: () => ({
        // menus: [],
        showCard: true
    }),
    methods: {
      showUpgradeGoldCard(menu) {
        if(!this.showCard && menu.label == 'Upgrade to Gold') {
          return false; 
        }
         return true;
      }
    },
    mounted() {
        // if (this.myInstitute && this.CUSTOM_INSTITUTE_ID.includes(this.myInstitute.id)) {
        //      this.menus = menuList.MENU.CUSTOMMENU;
        //  }else if (
        //     this.roleIds.CO === this.user.role_id ||
        //     this.roleIds.ID === this.user.role_id
        // ) {
        //     this.menus = menuList.MENU.COORDINATOR;
        // } else if (this.roleIds.ST === this.user.role_id) {
        //     this.menus = menuList.MENU.STUDENT;
        // } else if (this.roleIds.PA === this.user.role_id) {
        //     this.menus = menuList.MENU.PARENT;
        // } else if (this.roleIds.ED === this.user.role_id) {
        //     this.menus = menuList.MENU.DEO;
        // }
		    // else if (this.roleIds.TR === this.user.role_id) {
        //     this.menus = menuList.MENU.TEACHER;
        // }
        this.showCard = this.checkIsDefaultInstitute();
    },
    computed: {
        ...mapState("userStore", ["user","myInstitute"]),
        ...mapState("app", ["menus"]),

    }
};
</script>
